import { render, staticRenderFns } from "./TableWithDetails.vue?vue&type=template&id=a2b44908&scoped=true"
import script from "./TableWithDetails.vue?vue&type=script&lang=js"
export * from "./TableWithDetails.vue?vue&type=script&lang=js"
import style0 from "./TableWithDetails.vue?vue&type=style&index=0&id=a2b44908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b44908",
  null
  
)

export default component.exports